export const FormModelInsulationRequest = {
  requestorDetail: ['section', 'discipline'],
  workDetail: ['listWorkDetail'],
  scaffoldDetail: ['listScaffoldDetail'],
  insulationDetail: [
    'siteVisitDate',
    'area',
    'endDate',
    'workDescription',
    'startDate',
  ],
  paintingDetail: ['coatingSystem', 'serviceCateogry', 'environment'],
};

export const STATUS_OF_INSULATION = {
  VIEW_SUBMIT_SUCCESS: 'view-submit-success',
  VIEW_DETAIL: 'view-detail',
  EDIT_REQUEST: 'edit-request',
  CREATE_REQUEST: 'create-request',
};

export const LIST_KEY_CREATE_REQUEST = {
  REQUESTOR_DETAIL: 'requestorDetail',
  WORK_DETAIL: 'workDetail',
  SCAFFOLD_DETAIL: 'scaffoldDetail',
  INSULATION_DETAIL: 'insulationDetail',
  PAINTING_WORK_DETAIL: 'paintingWorkDetail',
  QAQC_DETAIL: 'qaqcDetail',
  SURFACE_PREPARATION_DETAIL: 'surfacePreparationDetail',
  PAINTING_EXECUTION_DETAIL: 'paintingExecutionDetail',
  PAINTING_DETAIL: 'paintingDetail',
  PROPOSAL_DETAIL: 'proposalDetail',
  REMOVAL_DETAIL: 'removalDetail',
  REINSTATEMENT_DETAIL: 'reinstatementDetail',
  FINAL_HAND_OVER: 'finalHandOver',
  IN_SERVICE: 'inService',
  PTW: 'ptw',
};

export const INSULATION_HEADERS = {
  REQUESTOR_DETAIL: 'Requestor Detail',
  WORK_DETAIL: 'Work Detail',
  SCAFFOLD_DETAIL: 'Scaffold Detail',
  INSULATION_DETAIL: 'Insulation Detail',
  PAINTING_DETAIL: 'Painting Detail',
  PROPOSAL_DETAIL: 'Proposal / Billing Detail',
  REMOVAL_DETAIL: 'Insulation Removal Detail',
  REINSTATEMENT_DETAIL: 'Insulation Reinstatement Detail',
  FINAL_HAND_OVER: 'Final Hand Over',
  QAQC_DETAIL: 'QAQC Detail',
  SURFACE_PREPARATION: 'Surface Preparation',
  PAINTING_EXECUTION: 'Painting Execution',
  PAINTING_WORK_DETAIL: 'Painting Work Detail',
  PTW: 'PTW',
};

export const REQUEST_TYPE = {
  INSTATEMENT: 'reinstatement-only',
  REMOVAL: 'removal-and-reinstatement',
  PAINTING: 'painting-request',
  SCAFFOLDING: 'scaffolding-request',
};

export const TYPE_OF_WORK = [
  {
    tilte: 'Insulation Request',
    label: 'Reinstatement ONLY',
    id: 1,
    icon: 'insulation',
    link: REQUEST_TYPE.INSTATEMENT,
  },
  {
    tilte: 'Insulation Request',
    label: 'Removal and Reinstatement',
    id: 2,
    icon: 'insulation',
    link: REQUEST_TYPE.REMOVAL,
  },
  {
    tilte: 'Painting Request',
    label: '',
    id: 3,
    icon: 'painting',
    link: REQUEST_TYPE.PAINTING,
  },
  {
    tilte: 'Scaffolding Request',
    label: '',
    id: 4,
    icon: 'scaffolding',
    link: process.env.REACT_APP_CREATE_SCAFFOLD_URL,
  },
];

export const ROLE_LIST = {
  REQUESTOR: 'requestor',
  INSULATION_TEAM: 'insulation-team',
  PAINTING_TEAM: 'painting-team',
  CONTRACTOR: 'contractor',
  ADMINISTRATOR: 'administrator',
};

export const LIST_MODEL = {
  [LIST_KEY_CREATE_REQUEST.REQUESTOR_DETAIL]: ['section', 'discipline'],
  [LIST_KEY_CREATE_REQUEST.WORK_DETAIL]: ['listWorkDetail'],
  [LIST_KEY_CREATE_REQUEST.SCAFFOLD_DETAIL]: ['listScaffoldDetail'],
  [LIST_KEY_CREATE_REQUEST.INSULATION_DETAIL]: [
    'siteVisitDate',
    'area',
    'endDate',
    'workDescription',
    'startDate',
  ],
  [LIST_KEY_CREATE_REQUEST.PAINTING_DETAIL]: ['siteEnvironment'],
  [LIST_KEY_CREATE_REQUEST.REMOVAL_DETAIL]: [
    'insulationRemovalDetail.completionDate',
    'insulationRemovalDetail.workLeaderId',
  ],
  [LIST_KEY_CREATE_REQUEST.REINSTATEMENT_DETAIL]: [
    'insulationReinstatementDetail.completionDate',
    'insulationReinstatementDetail.workLeaderId',
  ],
};

export const SAP_STATUS_LIST = [
  {
    id: 'NOCO',
    label: 'Notification completed',
  },
  {
    id: 'NORP',
    label: 'Notification in process',
  },
  {
    id: 'ORAS',
    label: 'Order assigned',
  },
  {
    id: 'OSNO',
    label: 'Outstanding notification',
  },
];

export const MAP_REQUEST_NAME = {
  DRAFT: 'Request Creation',
  PENDING_VALIDATION: 'Request Validation',
  PROPOSAL: 'Proposal',
};
